import _ from './underscore.js';
import './toPath.js';

// Internal wrapper for `_.toPath` to enable minification.
// Similar to `cb` for `_.iteratee`.
export default function toPath(path) {
  return _.toPath(path);
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/_toPath.js
// module id = 104
// module chunks = 0